import { defineMessage } from 'services/localization';

export const messages = {
    titleEdit: defineMessage('edit_contact_payment_details'),
    titleNew: defineMessage('add_contact_payment_details'),
    save: defineMessage('save'),
    helpText: defineMessage('what_are_contact_payment_details'),
    learnMore: defineMessage('learn_more'),
    inputPlaceholder: defineMessage('enter'),
    selectPlaceholder: defineMessage('select'),
    defaultCheckbox: defineMessage('set_as_default'),
    payeeBankCountry: defineMessage('bank_account_country'),
    payerBankCountry: defineMessage('contact_country'),
    accountCurrency: defineMessage('account_currency'),
    validationError: defineMessage('some_of_the_information_s_are_entered_correctly'),
    areYouSureToRemove: defineMessage('are_you_sure_you_want_t_ove_the_payment_details'),
    cancel: defineMessage('cancel'),
    submitRemove: defineMessage('yes_remove'),
    remove: defineMessage('remove'),
    confirmTitle: defineMessage('are_you_sure_you_want_to_continue'),
    confirmDescription: defineMessage('paying_this_person_or_b_cover_the_money_for_you'),
    confirmButtonMessage: defineMessage('confirm'),
};
